import { Account, Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function changePlanzone(httpClient: HttpClient) {
  return (account: Identifiable<Account>, planzone: Identifiable<Planzone>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/switch?planzoneTo=${planzone.uuid}`,
      method: HttpMethods.PATCH,
    });
}

export { changePlanzone };
